import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-neutral-sentiment-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfNeutralSentimentIconProps extends SvgIconProps {}

/**
 * Component used to display Neutral Sentiment icon
 * @param props - CcfNeutralSentimentIconProps
 * @returns
 * @example
 */
export function CcfNeutralSentimentIcon(props: CcfNeutralSentimentIconProps) {
  return (
    <SvgIcon width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
      <g clip-path="url(#clip0_2960_1562)">
        <path
          d="M7 0C3.15 0 0 3.15 0 7C0 10.85 3.15 14 7 14C10.85 14 14 10.85 14 7C14 3.15 10.85 0 7 0ZM7 12.6C3.92 12.6 1.4 10.08 1.4 7C1.4 3.92 3.92 1.4 7 1.4C10.08 1.4 12.6 3.92 12.6 7C12.6 10.08 10.08 12.6 7 12.6ZM6.3 5.04C6.3 4.27 5.67 3.64 4.9 3.64C4.13 3.64 3.5 4.27 3.5 5.04C3.5 5.81 4.13 6.44 4.9 6.44C5.67 6.44 6.3 5.81 6.3 5.04ZM9.1 3.64C8.33 3.64 7.7 4.27 7.7 5.04C7.7 5.81 8.33 6.44 9.1 6.44C9.87 6.44 10.5 5.81 10.5 5.04C10.5 4.27 9.87 3.64 9.1 3.64ZM9.1 8.4H4.9C4.48 8.4 4.2 8.68 4.2 9.1C4.2 9.52 4.48 9.8 4.9 9.8H9.1C9.52 9.8 9.8 9.52 9.8 9.1C9.8 8.68 9.52 8.4 9.1 8.4Z"
          fill="#E07E5F"
        />
      </g>
      <defs>
        <clipPath id="clip0_2960_1562">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default CcfNeutralSentimentIcon;
